import { Model } from '@vuex-orm/core';

export default class AccountingInfoRepository {
    public static getAll(model: typeof Model) {
        return model.all();
    }

    public static getById(model: typeof Model, id: string | number) {
        return model.query().whereId(id).first();
    }

    public static getByCode(model: typeof Model, code: string) {
        return model.query().where('code', code).first();
    }
}